import React from 'react'
import StampDuty from "website/how-to-apply/stamp-duty.svg"

const IconTextCard = ({
  link,
  icon,
  header,
  iconStyle,
  body
}) => {
  return (
    <div className='icon-text-card-wrapper'>
      <a className='icon-text-card-wrapper__link' href={link}>
        <div className='icon-text-card'>
          <div className={`icon-text-card__icon ${iconStyle}`}>
            {icon}
          </div>
          <div>
            <div className='icon-text-card__title'>
              {header}
            </div>
            <div className='icon-text-card__text'>
              {body}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}

export default IconTextCard
